import type { SystemRelationshipTarget } from '@cli-types/core-engine/schema.js'
import { USER_RELATIONSHIP_TARGET } from '@cli-constants/schema.js'

export function isUserRelationshipTarget(
  relationship: string | null | undefined
): relationship is SystemRelationshipTarget {
  return relationship === USER_RELATIONSHIP_TARGET
}
